package gr.tech.pdfgenerator.models.projects

import kotlinx.serialization.Serializable

@Serializable
data class ProjectsDTO(
    var id: Int? = null,
    var projectTitle: String? = null,
    var projectData: ProjectDataDTO? = null, //String/JSONB on backend.
    var description: String? = null,
    var status: Short? = null,
    var createdAt: String? = null,
    var createdBy: String? = null,
    var updatedAt: String? = null,
    var updatedBy: String? = null
)